import { CheckedUser } from '../nickname-bonus/nickname-bonus.entity';

import { BonusCode } from './bonus-codes.entity';

export enum UserCodeTypes {
  PROMOCODE = 'promo_code',
  SECRET_CODE = 'secret_code',
}

export namespace UserBonusApiResponse {
  export type PaymentBonuses = {
    maxBonusPct: number;
  } & BonusInfo & UserBenefits;
}

export interface UserBenefitsPercents {
  nickPrc: string|null;
  refPrc: number|null;
  secretCodePrc: number|null;
}

export interface UserBenefits {
  nickname: CheckedUser|null;
  referralBonus: number;
  secretCode: BonusCode|null;
}

export interface BonusInfo {
  totalBonusUsd: number;
  totalBonusPct: number;
  maxBonusUsd: number;
  maxBonusPct: number;
}
